import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_yourGoals.css'
import trainingPlans from 'images/app-page/your-goals/training-plans-screen.png'
import goals from 'images/app-page/your-goals/training-plans.png'

function YourGoals (props) {
  const { slug } = props.site
  const flavorClass = styles[slug] || ''

  return (
    <div className={styles.yourGoalsWrapper}>
      <div className={`${styles.yourGoals} ${flavorClass}`}>
        <div className={styles.content}>
          <Title color='black'>
            <FormattedMessage id='appPage.yourGoals.title' defaultMessage={`Your Goals.\n Your Coach.`} />
          </Title>
          <Caption color='black'>
            <FormattedMessage
              id='appPage.yourGoals.caption'
              defaultMessage='Reach your first mile or marathon with features like Training Plans and Audio Coaching.'
            />
          </Caption>
        </div>
        <div className={styles.goals}>
          <img src={goals} />
        </div>
        <div className={styles.trainingPlans}>
          <img src={trainingPlans} />
        </div>
        <div className={styles.runner} />
      </div>
    </div>
  )
}

YourGoals.propTypes = {
  site: PropTypes.object,
}

export default YourGoals
